<div style="text-align: center; background-color:#cc953e; height: 20px; padding-bottom: 31px">
  <div id="google_translate_element"></div>
</div>

<!-- WRAPPER -->
 <div class="app-header" style="height: 25vh !important;">
   <div class="tf-container">
      <div class="tf-topbar">
         <p class="text-white" style="font-size: 20px; font-weight:700; text-align: center;">Welcome, {{ user }}</p>
         <br>
         <!-- <p style="color: white; text-align: center;">Purchase a package below</p> -->
         <hr>
      </div>
   </div>
</div>

<div class="tf-container" >

    <div class="tf-balance-box" style="position: relative; margin-top: -90px; background-color: white; height: auto; min-height: 100vh; ">

      <router-outlet></router-outlet>
    </div>



</div>

<div class="bottom-navigation-bar" style="background-color: #03162b; margin-top: 0px;">
   <div class="tf-container">
      <ul class="tf-navigation-bar">
         <li class="active">
            <a style="color: white;" class="fw_6 d-flex justify-content-center align-items-center flex-column" routerLink="/dashboard"><i class="fa fa-home" style="font-size: 26px; margin-bottom: 4px;"></i> Home</a>
         </li>
         <li class="active">
            <a style="color: white;" class="fw_4 d-flex justify-content-center align-items-center flex-column" routerLink="/dashboard/capture"><i class="fa fa-bank" style="font-size: 26px; margin-bottom: 4px;"></i> Vault</a>
         </li>
         <li class="active">
            <a style="color: white;" class="fw_4 d-flex justify-content-center align-items-center flex-column" routerLink="/dashboard/history"><i class="fa fa-history" style="font-size: 26px; margin-bottom: 4px;"></i>
            Transactions</a>
         </li>
         <li class="active">
            <a style="color: white;" class="fw_4 d-flex justify-content-center align-items-center flex-column" routerLink="/dashboard/profile"><i class="fa fa-user" style="font-size: 26px; margin-bottom: 4px; line-height: 16px;"></i> Profile</a>
         </li>
      </ul>
      <!-- <span class="line"></span> -->
   </div>
</div>
